import {Storage} from "@/Services/Storage"

export const authentication = {
    async isUserLoggedIn() {
        let user = await Storage.getCurrentUser();
        return !!user;
    },

}